import React from 'react';
import { isNilOrEmpty } from '@pcty/utils';
import { AccessibleStatus } from '@citrus/accessibility';
export var AutoCompleteResults = function (_a) {
    var autocomplete = _a.autocomplete, count = _a.count, id = _a.id, open = _a.open, selected = _a.selected, value = _a.value;
    if (!autocomplete)
        return null;
    var getStatus = function () {
        if (isNilOrEmpty(value))
            return;
        if (selected && !open) {
            return "".concat(value, " selected.");
        }
        if (open && count === 1) {
            return "".concat(count, " result are available.");
        }
        if (open) {
            return "".concat(count, " results are available.");
        }
        return '';
    };
    return React.createElement(AccessibleStatus, { id: id, message: getStatus() });
};
